import React, { FC } from "react";
import { Box, Text } from "@primer/react";
import { BaseDialog } from "@getregistered/greg-editors/dist/lib/primer-ui/BaseDialog/BaseDialog";
import { StatusBreakdown } from "./RegistrationStatusContent";

interface ResendConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectionCount: number;
  preflightCounts?: Record<string, number>;
}

const describeResendRow = (status: string) =>
  status === "confirmed"
    ? "These rows will receive a confirmation email"
    : "These rows will be skipped (not confirmed)";

export const ResendConfirmationModal: FC<ResendConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectionCount,
  preflightCounts,
}) => {
  const attendeeLabel = selectionCount === 1 ? "attendee" : "attendees";
  const rightButtonText = `Resend to ${selectionCount} ${attendeeLabel}`;

  return (
    <BaseDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Resend Confirmation Email"
      position="center"
      width="600px"
      leftButtonText="Go back"
      rightButtonText={rightButtonText}
      rightButtonVariant="primary"
      onLeftButtonClick={onClose}
      onRightButtonClick={onConfirm}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Text as="div" fontSize={1}>
          Resending confirmation email to{" "}
          <Text as="span" fontWeight="bold">{selectionCount} {attendeeLabel}</Text>
        </Text>

        {preflightCounts && (
          <StatusBreakdown
            counts={preflightCounts}
            targetStatus="confirmed"
            describeRow={describeResendRow}
          />
        )}

        <Text as="div" fontSize={1}>
          Only confirmed registrations will receive the email. Other statuses are skipped.
        </Text>
      </Box>
    </BaseDialog>
  );
};
